import { FC } from "react";
import { TOfferCardProps } from "./OfferCard.config";
import { Inline, Stack } from "@/ui/components/layout";
import { Button, Image } from "@/ui/components/primitives";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextControl } from "@/ui/components/typography/TextControl";

export const OfferCard: FC<TOfferCardProps> = ({ title, body, footer, image, cta }) => (
  <Stack data-component="OfferCard" className="bg-sys-white p-4 rounded-sys-lg">
    <Inline gap="2">
      <div className="w-16">
        <Image {...image} />
      </div>
      <Stack gap="2">
        <TextSubtitle tag="h3" size={2} isResponsive={false}>
          { title }
        </TextSubtitle>
        <Stack className="text-foreground-muted-strong" gap="2">
          <TextBody size={2} isResponsive={false} color="inherit">
            { body }
          </TextBody>
          <TextControl size={3} isResponsive={false} color="inherit">
            { footer }
          </TextControl>
        </Stack>
      </Stack>
    </Inline>
    <Button {...cta} className="w-full" />
  </Stack>
);
